import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';

import './Servizi.css';
import brands from './util';

class Servizi extends Component {

    renderBrands() {
        return brands.map((b, i) => {
            return (
                <Grid key={`brand-${i}`} item xs={12} sm={6} md={3} className='grid-brand'>
                    <div className='marchio'>
                        <a href={b.url} target='_blank' rel='noopener noreferrer'><img src={b.logo} alt={b.name} /></a>
                    </div>
                </Grid>
            );
        });
    }
    render() {
        return (
            <Grid item xs={12} id='servizi'>
                <Grid container>
                    <Grid item xs={12}>
                        <h1 className='slide-title'>Servizi</h1>
                    </Grid>
                    {this.renderBrands()}
                </Grid>
            </Grid>
        );
    }
}

export default Servizi;